/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: k0sjE64BjPfV
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicBreadcrumb.module.css"; // plasmic-import: k0sjE64BjPfV/css

createPlasmicElementProxy;

export const PlasmicBreadcrumb__VariantProps = new Array(
  "crumbCount",
  "sidePadding",
  "size",
  "bgColor"
);

export const PlasmicBreadcrumb__ArgProps = new Array(
  "tabTitle",
  "crumb1",
  "crumb2",
  "crumb3"
);

const $$ = {};

function PlasmicBreadcrumb__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          tabTitle: "tabTitle",
          crumb1: "crumb1",
          crumb2: "crumb2",
          crumb3: "crumb3"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "crumbCount",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.crumbCount
      },
      {
        path: "sidePadding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.sidePadding
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.size
      },
      {
        path: "bgColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.bgColor
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootbgColor_noBackground]: hasVariant(
            $state,
            "bgColor",
            "noBackground"
          ),
          [sty.rootcrumbCount_justTitle]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.rootcrumbCount_title1Crumb]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.rootcrumbCount_title2Crumbs]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.rootsidePadding_noPaddong]: hasVariant(
            $state,
            "sidePadding",
            "noPaddong"
          ),
          [sty.rootsidePadding_smallPadding]: hasVariant(
            $state,
            "sidePadding",
            "smallPadding"
          ),
          [sty.rootsize_navS]: hasVariant($state, "size", "navS"),
          [sty.rootsize_nav]: hasVariant($state, "size", "nav")
        }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__cagL, {
          [sty.freeBoxcrumbCount_title1Crumb__cagLMyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__cagLZ35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          )
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__c3AiB,
            {
              [sty.textcrumbCount_justTitle__c3AiBeN0KV]: hasVariant(
                $state,
                "crumbCount",
                "justTitle"
              ),
              [sty.textcrumbCount_title1Crumb__c3AiBmyJ0]: hasVariant(
                $state,
                "crumbCount",
                "title1Crumb"
              ),
              [sty.textcrumbCount_title2Crumbs__c3AiBz35N5]: hasVariant(
                $state,
                "crumbCount",
                "title2Crumbs"
              ),
              [sty.textcrumbCount_title3Crumbs__c3AiBByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__c3AiBcjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.tabTitle;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__ceSo9, {
          [sty.freeBoxcrumbCount_justTitle__ceSo9EN0KV]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.freeBoxcrumbCount_title1Crumb__ceSo9MyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__ceSo9Z35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.freeBoxsize_navS__ceSo9CjjH]: hasVariant($state, "size", "navS")
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__dlf96,
            {
              [sty.textcrumbCount_title1Crumb__dlf96MyJ0]: hasVariant(
                $state,
                "crumbCount",
                "title1Crumb"
              ),
              [sty.textcrumbCount_title2Crumbs__dlf96Z35N5]: hasVariant(
                $state,
                "crumbCount",
                "title2Crumbs"
              ),
              [sty.textcrumbCount_title3Crumbs__dlf96ByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__dlf96CjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          {"/"}
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__wysnm, {
          [sty.freeBoxcrumbCount_justTitle__wysnmeN0KV]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.freeBoxcrumbCount_title1Crumb__wysnmmyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__wysnmZ35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.freeBoxsize_navS__wysnmcjjH]: hasVariant($state, "size", "navS")
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__q22Tw,
            {
              [sty.textcrumbCount_title1Crumb__q22TwmyJ0]: hasVariant(
                $state,
                "crumbCount",
                "title1Crumb"
              ),
              [sty.textcrumbCount_title2Crumbs__q22TwZ35N5]: hasVariant(
                $state,
                "crumbCount",
                "title2Crumbs"
              ),
              [sty.textcrumbCount_title3Crumbs__q22TwByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__q22TwcjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.crumb1;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "enter some text";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__m9LVi, {
          [sty.freeBoxcrumbCount_justTitle__m9LVIeN0KV]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.freeBoxcrumbCount_title1Crumb__m9LVImyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__m9LViz35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.freeBoxsize_navS__m9LVIcjjH]: hasVariant($state, "size", "navS")
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__zneTs,
            {
              [sty.textcrumbCount_title1Crumb__zneTsmyJ0]: hasVariant(
                $state,
                "crumbCount",
                "title1Crumb"
              ),
              [sty.textcrumbCount_title2Crumbs__zneTsZ35N5]: hasVariant(
                $state,
                "crumbCount",
                "title2Crumbs"
              ),
              [sty.textcrumbCount_title3Crumbs__zneTsByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__zneTscjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          {"/"}
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__z5WW6, {
          [sty.freeBoxcrumbCount_justTitle__z5WW6EN0KV]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.freeBoxcrumbCount_title1Crumb__z5WW6MyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__z5WW6Z35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.freeBoxsize_navS__z5WW6CjjH]: hasVariant($state, "size", "navS")
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__koraG,
            {
              [sty.textcrumbCount_title2Crumbs__koraGz35N5]: hasVariant(
                $state,
                "crumbCount",
                "title2Crumbs"
              ),
              [sty.textcrumbCount_title3Crumbs__koraGByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__koraGcjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.crumb2;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "enter some text";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__xxbzL, {
          [sty.freeBoxcrumbCount_justTitle__xxbzLeN0KV]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.freeBoxcrumbCount_title1Crumb__xxbzLmyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__xxbzLz35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.freeBoxsize_navS__xxbzLcjjH]: hasVariant($state, "size", "navS")
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__hgQb,
            {
              [sty.textcrumbCount_title3Crumbs__hgQbByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__hgQBcjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          {"/"}
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__rn3QV, {
          [sty.freeBoxcrumbCount_justTitle__rn3QVeN0KV]: hasVariant(
            $state,
            "crumbCount",
            "justTitle"
          ),
          [sty.freeBoxcrumbCount_title1Crumb__rn3QVmyJ0]: hasVariant(
            $state,
            "crumbCount",
            "title1Crumb"
          ),
          [sty.freeBoxcrumbCount_title2Crumbs__rn3QVz35N5]: hasVariant(
            $state,
            "crumbCount",
            "title2Crumbs"
          ),
          [sty.freeBoxsize_navS__rn3QVcjjH]: hasVariant($state, "size", "navS")
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__cajyr,
            {
              [sty.textcrumbCount_title3Crumbs__cajyrByWLf]: hasVariant(
                $state,
                "crumbCount",
                "title3Crumbs"
              ),
              [sty.textsize_navS__cajyrcjjH]: hasVariant($state, "size", "navS")
            }
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.crumb3;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "enter some text";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBreadcrumb__ArgProps,
          internalVariantPropNames: PlasmicBreadcrumb__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBreadcrumb__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBreadcrumb";
  } else {
    func.displayName = `PlasmicBreadcrumb.${nodeName}`;
  }
  return func;
}

export const PlasmicBreadcrumb = Object.assign(
  // Top-level PlasmicBreadcrumb renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicBreadcrumb
    internalVariantProps: PlasmicBreadcrumb__VariantProps,
    internalArgProps: PlasmicBreadcrumb__ArgProps
  }
);

export default PlasmicBreadcrumb;
/* prettier-ignore-end */
